import React, { FC } from 'react'
import { IonFooter } from '@ionic/react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { payPlanMobx, payRechargeMobx } from '@mobxStore'
import { loadingLayer, modalLayer, toastLayer, getHistoryNew, getPlatform } from '@utils'
import { format, delayTime } from '@dt/fe-utils'
import { payOrder, payOrderReset } from '@common/utils/pay'
import { ConfirmModal } from '@cps'
import { SettlementCard, PayAndRecharge, PayOther } from '@pages/checkout/component'
import '@pages/checkout/component/CartFooter/index.scss'

const CartFooter: FC = () => {
  const history = getHistoryNew()
  const { isWeixinMiniProgram } = getPlatform()

  // 处理支付动作
  const handlePayAction = async () => {
    modalLayer.closeAll()
    // 直接支付(支付金额0、会员余额能全额支付)
    if ((payPlanMobx.totalAmount || (!payPlanMobx.totalAmount && payRechargeMobx.rechargeInfo)) && !payRechargeMobx.memberCardCanFullpay) {
      if (payRechargeMobx.rechargeInfo) {
        modalLayer(PayAndRecharge, null, 'payAndRechargeModal')
          .then(() => { })
          .catch(() => {
            payPlanMobx.beginCalc()
          })
      } else {
        modalLayer(SettlementCard, null, 'settlementCardModal')
          .then(() => { })
          .catch(async () => {
            // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {
            // }
            await discountMobx.deleteOnlyBalancePay()
            await delayTime(500)
            await discountMobx.setOnlyBalancePay(true)
          })
      }
    } else {
      payOrder({
        history,
        handlePayAction,
        handlePayError: (forceOrder) => {
          modalLayer.closeAll()
          modalLayer(ConfirmModal, {
            title: i18n.t('common.attention'),
            confirmText: i18n.t('checkout.confirmRefresh'),
            children: (<span>{i18n.t('checkout.payOrderHasError')}</span>),
            className: 'cart-confirm-modal',
            backdropDismiss: false
          }, 'confirmModal').then(async () => {
            modalLayer.closeAll()
            loadingLayer.show()
            await payOrderReset(forceOrder)
            loadingLayer.hide()
          }).catch(() => {})
        }
      })
    }
  }

  const handleOtherPayAction = async () => {
    // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {
    // }
    await discountMobx.setOnlyBalancePay(false)

    await payPlanMobx.setMemberCardPayAmount(0)
    modalLayer.closeAll()
    modalLayer(SettlementCard, null, 'settlementCardModal')
      .then(() => {})
      .catch(async () => {
        // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {
        // }
        await discountMobx.deleteOnlyBalancePay()
        await delayTime(500)
        await discountMobx.setOnlyBalancePay(true)
        await payPlanMobx.setMemberCardPayAmount(payPlanMobx.totalAmountOffThirdCouponPrice)
      })
    // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {
    // }
    setTimeout(() => toastLayer.info(i18n.t('pay.notMemberCardFullPayTip')), 500)
  }

  return (
    <IonFooter className='cart-footer'>
      {
        payRechargeMobx.memberCardCanFullpay && payPlanMobx.totalAmount > 0 && (
          <PayOther onClick={handleOtherPayAction} />
        )
      }
      <div className='cart-button-footer'>
        <button onClick={handlePayAction}>
          {i18n.t(isWeixinMiniProgram ? 'menu.go_pay' : 'pay.pay')} <big dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(payPlanMobx.totalAmount) }}></big>
        </button>
      </div>
    </IonFooter>
  )
}

export default observer(CartFooter)
